import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroContent } from '@/hooks/useContent';

const Hero = () => {
  const content = heroContent;

  const scrollToSection = (target) => {
    const element = document.getElementById(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center" data-testid="hero-section">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${content.background_image})`,
        }}
      >
        <div 
          className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"
          style={{ opacity: content.styling?.overlay_opacity || 0.5 }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <h1 
            className="hero-title text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
            style={{ color: content.styling?.text_color || '#FFFFFF' }}
            data-testid="hero-headline"
          >
            {content.headline}
          </h1>
          <p 
            className="hero-subtitle text-xl md:text-2xl mb-8 leading-relaxed"
            style={{ color: `${content.styling?.text_color || '#FFFFFF'}e6` }}
            data-testid="hero-subheadline"
          >
            {content.subheadline}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => scrollToSection(content.primary_cta_target)}
              className="hero-cta-primary px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 group"
              data-testid="hero-primary-cta"
            >
              {content.primary_cta_text}
              <ArrowRight className="group-hover:translate-x-1 transition-transform duration-300" size={20} />
            </button>
            <button 
              onClick={() => scrollToSection(content.secondary_cta_target)}
              className="hero-cta-secondary px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300"
              data-testid="hero-secondary-cta"
            >
              {content.secondary_cta_text}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="scroll-indicator animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/70 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
